export default __webpack_public_path__ + "static/media/hyl-app-download-link-qrcode.7d97b738.svg";